module.exports = __webpack_public_path__ + "static/media/50cent.a2fbde40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/50cent.png
// module id = 926
// module chunks = 0